/**
 * @author shreyas.hande on 6/11/18
 *
 */

import { CONFIG_EVENTS } from '../../constants/events';

const defaultState = {};

const ConfigReducer = (state = defaultState, action) => {
    switch (action.type) {
        case CONFIG_EVENTS.UPDATE_CONFIG:
            state = Object.assign({}, state, action.payload.config);
    }
    return state;
};

export default ConfigReducer;



// WEBPACK FOOTER //
// ../q-jobs/src/reducers/ConfigReducer/index.js